















































import { Component, Vue, Prop, Ref, Watch } from "vue-property-decorator";

import NewSurveyAddressDialog from "@/components/NewSurveyAddressDialog.vue";
import { TPTPlaceResult, GeometryLocation, Question } from "@/interfaces";
import Map from "@/components/Map.vue";

@Component({
  components: {
    Map,
  },
})
export default class SurveyMap extends Vue {
  @Prop({ type: Array, default: () => [] })
  value!: TPTPlaceResult[];

  @Prop({ type: Array, required: true })
  places!: TPTPlaceResult[];

  @Prop({ type: String, default: () => "" })
  label!: string;

  @Prop({ type: Object, required: true })
  question!: Question;

  @Ref("survey-custom-map")
  map!: Map;

  center: GeometryLocation = {
    lat: 43.416667,
    lng: 11,
  };

  filteredPlaces: TPTPlaceResult[] = [];

  selectedPlaces: TPTPlaceResult[] = [];

  mounted() {
    this.filteredPlaces = this.places;
    this.selectedPlaces = this.value;
  }

  onAddPlace() {
    this.$q
      .dialog({
        component: NewSurveyAddressDialog,
        parent: this,
        title: `Aggiungi ${this.elementName}`,
      })
      .onOk((place: TPTPlaceResult) => {
        const find = this.filteredPlaces.find(findPlace => findPlace.place_id === place.place_id);

        if (!find) {
          this.filteredPlaces = [...this.filteredPlaces, place];

          if (this.question.conf && this.question.conf.max !== undefined) {
            if (this.selectedPlaces.length < this.question.conf.max) {
              this.selectedPlaces.push(place);
            }
          } else {
            this.selectedPlaces.push(place);
          }
        }
      });
  }

  @Watch("selectedPlaces")
  onSelectedPlacesChange() {
    this.map.removeMarkers();

    this.selectedPlaces.forEach(place => {
      if (place.geometry && place.geometry.location !== null) {
        this.map.addMarker(place.geometry.location);
      }
    });

    this.$emit("input", this.selectedPlaces);
  }

  get disableCheckBoxCondition() {
    return (place: TPTPlaceResult) => {
      const validation = this.selectedPlaces.find(plc => plc.place_id === place.place_id);
      const fullValidation =
        this.question.conf &&
        (this.question.conf.readonly ||
          (this.selectedPlaces.length === this.question.conf.max && validation === undefined));

      return fullValidation || place.disabled;
    };
  }

  get elementName() {
    if (this.question.conf && this.question.conf.item_name) {
      return this.question.conf.item_name;
    }
    return "elemento";
  }
}
